// app/javascript/compcalc/components/utls/ReactCardFlip.jsx

import React from 'react';
import PropTypes from 'prop-types';

class ReactCardFlip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFlipped: this.props.isFlipped,
      rotation: 0
    };
  }

  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.isFlipped !== this.props.isFlipped) {
  //     this.setState({ isFlipped: nextProps.isFlipped });
  //     this.setState({ rotation: this.state.rotation + 180 });
  //   }
  // }

  static getDerivedStateFromProps(props, state) {
    return {
      isFlipped: props.isFlipped,
      rotation: state.rotation + 180
    }
  }
  
  getComponent(key) {
    return this.props.children.filter(component => {
      return component.key === key;
    });
  }

  render() {
    const {
      useOpacity,
      flipDirection,
      infinite,
      flipSpeedFrontToBack,
      flipSpeedBackToFront,
      cardStyles: { front, back },
      cardZIndex
    } = this.props;
    const { isFlipped, rotation } = this.state;

    const frontRotate = infinite ? rotation : isFlipped ? 180 : 0;
    const backRotate = infinite ? rotation + 180 : isFlipped ? 0 : -180;

    const frontRotateY = `rotateY(${frontRotate}deg)`;
    const backRotateY = `rotateY(${backRotate}deg)`;

    const frontRotateX = `rotateX(${frontRotate}deg)`;
    const backRotateX = `rotateX(${backRotate}deg)`;

    const transformFront = (flipDirection === 'horizontal' ? frontRotateY : frontRotateX);
    const transformBack = (flipDirection === 'horizontal' ? backRotateY : backRotateX);

    const frontSelf = this.props.useOpacity ? {
      opacity: isFlipped ? '0' : '1',
    } : {
      transform: transformFront,
      WebkitTransform: transformFront,
      transformStyle: 'preserve-3d',
    };

    const backSelf = this.props.useOpacity ?{
      opacity: isFlipped ? '1' : '0',
    } : {
      transform: transformBack,
      WebkitTransform: transformBack,
      transformStyle: 'preserve-3d',
    };

    const isSafari = window.safari !== undefined;
    // console.log(`isSafari = ${isSafari}`);

    // Don't use perspective in Safari.
    const perspective = this.props.useOpacity || isSafari ? {
    } : {
      perspective: '1000px',
    };

    const styles = {
      container: {
        // background: 'yellow',
        // transform: 'scale(1)',
        transformStyle: 'preserve-3d',
        width: '100%',
        height: '100%',
        zIndex: `${cardZIndex}`,
        ...perspective
      },
      // flipper: {
      //   position: 'relative',
      //   transformStyle: 'preserve-3d'
      // },
      front: {
        // background: 'blue',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        // WebkitTransformOrigin: '51% 51%',
        // '-webkit-font-smoothing': 'subpixel-antialiased',
        // filter: 'none',
        // WebkitFilter: 'blur(0px)',
        // MozFilter: 'blur(0px)',
        // MsFilter: 'blur(0px)',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        // display: 'table-cell',
        // verticalAlign: 'center',
        // display: 'flex',
        // justifyContent: 'center',    // Horizontal align.
        // alignItems: 'stretch',        // Vertical align.
        position: isFlipped ? 'absolute' : 'relative',
        visibility: isFlipped ? 'hidden' : '',
        zIndex: '2',
        transition: `all ${flipSpeedBackToFront}s`,
        ...frontSelf,
        ...front
      },
      back: {
        // background: 'red',
        WebkitBackfaceVisibility: 'hidden',
        backfaceVisibility: 'hidden',
        // WebkitTransformOrigin: '51% 51%',
        // '-webkit-font-smoothing': 'subpixel-antialiased',
        // filter: 'none',
        // WebkitFilter: 'blur(0px)',
        // MozFilter: 'blur(0px)',
        // MsFilter: 'blur(0px)',
        left: '0',
        top: '0',
        width: '100%',
        height: '100%',
        textAlign: 'center',
        // display: 'table-cell',
        // verticalAlign: 'center',
        // display: 'flex',
        // justifyContent: 'center',    // Horizontal align.
        // alignItems: 'stretch',        // Vertical align.
        position: isFlipped ? 'relative' : 'absolute',
        visibility: isFlipped ? '' : 'hidden',
        transition: `${flipSpeedFrontToBack}s`,
        zIndex: '3',
        ...backSelf,
        ...back
      }
    };

    // <div className="flipper" style={styles.flipper}>
    return (
      <div className="flip-container" style={styles.container}>
        <div className="flip-front" style={styles.front}>
          {this.getComponent('front')}
        </div>
        <div className="flip-back" style={styles.back}>
          {this.getComponent('back')}
        </div>
      </div>
    );
  }
}

ReactCardFlip.propTypes = {
  useOpacity: PropTypes.bool,
  cardStyles: PropTypes.shape({
    front: PropTypes.object,
    back: PropTypes.object
  }),
  cardZIndex: PropTypes.string,
  children: (props, propName, componentName) => {
    if (React.Children.count(props[propName]) !== 2) {
      return new Error(`${componentName} requires two children.`);
    }
  },
  flipDirection: (props, propName, componentName) => {
    if (!props[propName]) {
      return;
    }

    if (
      !(
        typeof props[propName] === 'string' || props[propName] instanceof String
      )
    ) {
      return new Error(`${propName} requires a string.`);
    }

    if (
      props[propName].toLowerCase() !== 'horizontal' &&
      props[propName].toLowerCase() !== 'vertical'
    ) {
      return new Error(
        `${propName} expects (horizontal|vertical), got ${props[
          propName
        ].toLowerCase()}`
      );
    }
  },
  flipSpeedBackToFront: PropTypes.number,
  flipSpeedFrontToBack: PropTypes.number,
  infinite: PropTypes.bool,
  isFlipped: PropTypes.bool
};

ReactCardFlip.defaultProps = {
  cardStyles: {
    front: {},
    back: {}
  },
  useOpacity: false,
  cardZIndex: '1',
  flipDirection: 'horizontal',
  flipSpeedBackToFront: 0.6,
  flipSpeedFrontToBack: 0.6,
  infinite: false,
  isFlipped: false
};

export default ReactCardFlip;